import type { GeocodeLocation } from '~/contracts/vm';

const R = 6371; // Radius of the earth in km

const km2mi = (value: number): number => value * 0.621371;

type DistanceResult = {
  hasError?: boolean;
  km: number;
  mi: number;
};

export const haversineDistance = (
  location1: GeocodeLocation,
  location2: GeocodeLocation
): DistanceResult => {
  const proper = location1 && location2;

  if (!proper) {
    return {
      km: 0,
      mi: 0,
      hasError: true
    };
  }

  const { lat: lat1, lng: lon1 } = location1;
  const { lat: lat2, lng: lon2 } = location2;

  const dLat = ((lat2 - lat1) * Math.PI) / 180; // deg2rad below
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    0.5 -
    Math.cos(dLat) / 2 +
    (Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      (1 - Math.cos(dLon))) /
      2;

  const km = R * 2 * Math.asin(Math.sqrt(a));

  return {
    km,
    mi: km2mi(km)
  };
};
